import CraftItem from "../JSON/CraftItem.json";
import isEmpty from "./isEmpty";

const addItem = (obj, id, count) => (obj[id] = (obj[id] || 0) + count);

const extract = (source = {}, craftable = {}, materials = {}) => {
  if (isEmpty(source)) return { craftable, materials };

  const _source = {};
  const _craftable = { ...craftable };
  const _materials = { ...materials };

  Object.entries(source).forEach(([id, count]) => {
    if (count === 0) return;

    const craft = CraftItem[id];
    if (!craft) {
      addItem(_materials, id, count);
    } else {
      addItem(_craftable, id, count);
      const { recipe1, recipe1_count, recipe2, recipe2_count } = craft;
      if (recipe1) addItem(_source, recipe1, count * recipe1_count);
      if (recipe2) addItem(_source, recipe2, count * recipe2_count);
    }
  });

  return extract(_source, _craftable, _materials);
};

export default extract;
